module.exports = __webpack_public_path__ + "static/media/i_footer_cart.dde78ba0.png";